import { render, staticRenderFns } from "./reset-request.vue?vue&type=template&id=9c32311c&scoped=true&"
import script from "./reset-request.vue?vue&type=script&lang=js&"
export * from "./reset-request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c32311c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InputsBackendErrors: require('/var/www/jaty-frontend/components/inputs/BackendErrors.vue').default,InputsInput: require('/var/www/jaty-frontend/components/inputs/Input.vue').default,AuthFormSecondaryLink: require('/var/www/jaty-frontend/components/AuthFormSecondaryLink.vue').default})
